/**
 * Collection filter drawer + sort menu
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-bb-collection]');
  if (!section) return;

  var collectionUrl = section.dataset.collectionUrl || window.location.pathname;
  var brandVendor = section.dataset.brandVendor || '';
  var drawer = section.querySelector('[data-bb-col-filter-drawer]');
  var filterOpenBtn = section.querySelector('[data-bb-col-filter-open]');
  var sortRoot = section.querySelector('[data-bb-col-sort]');
  var sortTrigger = section.querySelector('[data-bb-col-sort-trigger]');
  var sortPanel = section.querySelector('[data-bb-col-sort-panel]');
  var applyBtn = section.querySelector('[data-bb-col-filter-apply]');
  var clearBtn = section.querySelector('[data-bb-col-filter-clear]');

  function getCurrentSortBy() {
    var params = new URLSearchParams(window.location.search);
    return params.get('sort_by') || '';
  }

  function buildBaseUrl(pathnameOrUrl) {
    var url;
    try {
      url = new URL(pathnameOrUrl || collectionUrl, window.location.origin);
    } catch (e) {
      url = new URL(window.location.pathname, window.location.origin);
    }
    // Keep alternate template views only when staying on the same collection path.
    var currentView = new URLSearchParams(window.location.search).get('view');
    var stayingOnCollection =
      url.pathname === window.location.pathname ||
      url.pathname === new URL(collectionUrl, window.location.origin).pathname;
    if (currentView && !url.searchParams.get('view') && stayingOnCollection) {
      url.searchParams.set('view', currentView);
    }
    return url;
  }

  function collectCheckedFilters() {
    var drawerEl = section.querySelector('[data-bb-col-filter-drawer]');
    var grouped = {};
    var scoped = [];
    if (!drawerEl) return { grouped: grouped, scoped: scoped };

    drawerEl.querySelectorAll('.bb-col-filter__checkbox:checked').forEach(function (cb) {
      var param = cb.dataset.param || cb.name;
      if (!param) return;
      if (!grouped[param]) grouped[param] = [];
      if (grouped[param].indexOf(cb.value) === -1) {
        grouped[param].push(cb.value);
      }
      if (cb.dataset.filterCollectionUrl) {
        scoped.push({
          value: cb.value,
          param: param,
          url: cb.dataset.filterCollectionUrl,
          isRange: String(cb.value).indexOf('product-range:') === 0,
        });
      }
    });

    return { grouped: grouped, scoped: scoped, drawerEl: drawerEl };
  }

  function applyGroupedParams(url, grouped, omit) {
    omit = omit || {};
    Object.keys(grouped).forEach(function (param) {
      url.searchParams.delete(param);
      grouped[param].forEach(function (val) {
        if (omit[param] && omit[param].indexOf(val) !== -1) return;
        url.searchParams.append(param, val);
      });
    });
  }

  function applyPriceParams(url, drawerEl) {
    if (!drawerEl) return;
    drawerEl.querySelectorAll('.bb-col-filter__price-input').forEach(function (input) {
      var param = input.dataset.param;
      if (!param) return;
      url.searchParams.delete(param);
      if (input.value !== '' && input.value != null) {
        url.searchParams.set(param, input.value);
      }
    });
  }

  /**
   * Tag URL filters need Search & Discovery "Product tag".
   * When a selection maps to a smart collection (range / taxonomy), go there instead.
   * From a brand Shop all page, taxonomy jumps keep the brand via filter.p.vendor.
   */
  function resolveFilterNavigation() {
    var collected = collectCheckedFilters();
    var grouped = collected.grouped;
    var scoped = collected.scoped;
    var omit = {};
    var basePath = collectionUrl;
    var usedTaxonomyCollection = false;

    var rangeScoped = scoped.filter(function (s) {
      return s.isRange;
    });
    var otherScoped = scoped.filter(function (s) {
      return !s.isRange;
    });

    if (rangeScoped.length === 1) {
      basePath = rangeScoped[0].url;
      omit[rangeScoped[0].param] = [rangeScoped[0].value];
      // Drop ?view=products — range smart collections use the default product grid.
    } else if (rangeScoped.length === 0 && otherScoped.length === 1) {
      var onlyTagValues = grouped['filter.p.tag'] || [];
      var hasNonScopedTags = onlyTagValues.some(function (val) {
        return !scoped.some(function (s) {
          return s.value === val;
        });
      });
      var hasOtherFacets = Object.keys(grouped).some(function (param) {
        return param !== 'filter.p.tag' && grouped[param].length > 0;
      });
      if (!hasNonScopedTags && !hasOtherFacets) {
        basePath = otherScoped[0].url;
        omit[otherScoped[0].param] = [otherScoped[0].value];
        usedTaxonomyCollection = true;
      }
    }

    var url = buildBaseUrl(basePath);
    // Leaving the brand ?view=products grid for a smart collection — clear view.
    if (basePath !== collectionUrl) {
      url.searchParams.delete('view');
    }
    applyGroupedParams(url, grouped, omit);
    applyPriceParams(url, collected.drawerEl);

    // Pestlo Shop all → Sun Protection must stay Pestlo-only, not every brand.
    if (usedTaxonomyCollection && brandVendor) {
      url.searchParams.delete('filter.p.vendor');
      url.searchParams.append('filter.p.vendor', brandVendor);
    }

    return url;
  }

  function navigateWithFilters(sortBy) {
    var url = resolveFilterNavigation();
    if (sortBy) {
      url.searchParams.set('sort_by', sortBy);
    } else {
      var current = getCurrentSortBy();
      if (current) url.searchParams.set('sort_by', current);
    }
    window.location.href = url.toString();
  }

  function openDrawer() {
    if (!drawer) return;
    closeSortPanel();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
  }

  function openSortPanel() {
    if (!sortPanel || !sortTrigger) return;
    closeDrawer();
    sortPanel.hidden = false;
    sortTrigger.setAttribute('aria-expanded', 'true');
    sortRoot.classList.add('is-open');
  }

  function closeSortPanel() {
    if (!sortPanel || !sortTrigger) return;
    sortPanel.hidden = true;
    sortTrigger.setAttribute('aria-expanded', 'false');
    if (sortRoot) sortRoot.classList.remove('is-open');
  }

  function removeFilterValue(param, value) {
    var url = new URL(window.location.href);
    var values = url.searchParams.getAll(param).filter(function (v) {
      return v !== value;
    });
    url.searchParams.delete(param);
    values.forEach(function (v) {
      url.searchParams.append(param, v);
    });
    window.location.href = url.toString();
  }

  function removePriceFilter(minParam, maxParam) {
    var url = new URL(window.location.href);
    url.searchParams.delete(minParam);
    url.searchParams.delete(maxParam);
    window.location.href = url.toString();
  }

  if (filterOpenBtn) {
    filterOpenBtn.addEventListener('click', openDrawer);
  }

  section.querySelectorAll('[data-bb-col-filter-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      closeDrawer();
      navigateWithFilters(getCurrentSortBy());
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      closeDrawer();
      var url = buildBaseUrl();
      var sort = getCurrentSortBy();
      if (sort) url.searchParams.set('sort_by', sort);
      window.location.href = url.toString();
    });
  }

  if (sortTrigger) {
    sortTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (sortRoot.classList.contains('is-open')) {
        closeSortPanel();
      } else {
        openSortPanel();
      }
    });
  }

  if (sortPanel) {
    sortPanel.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sortValue = btn.dataset.sortValue;
        var url = new URL(window.location.href);
        if (sortValue && sortValue !== 'manual') {
          url.searchParams.set('sort_by', sortValue);
        } else {
          url.searchParams.delete('sort_by');
        }
        window.location.href = url.toString();
      });
    });
  }

  section.querySelectorAll('[data-bb-col-chip-remove]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      removeFilterValue(chip.dataset.param, chip.dataset.value);
    });
  });

  section.querySelectorAll('[data-bb-col-chip-remove-price]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      removePriceFilter(chip.dataset.minParam, chip.dataset.maxParam);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeSortPanel();
    }
  });

  document.addEventListener('click', function (e) {
    if (sortRoot && !sortRoot.contains(e.target)) {
      closeSortPanel();
    }
  });

  function accordionHasSelection(details) {
    if (!details) return false;
    if (details.querySelector('.bb-col-filter__checkbox:checked')) return true;
    return Array.prototype.some.call(
      details.querySelectorAll('.bb-col-filter__price-input'),
      function (input) {
        return input.value !== '' && input.value != null;
      }
    );
  }

  section.querySelectorAll('.bb-col-filter__checkbox').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var accordion = cb.closest('.bb-col-filter__accordion');
      if (accordion && cb.checked) {
        accordion.open = true;
      }
    });
  });

  section.querySelectorAll('.bb-col-filter__price-input').forEach(function (input) {
    input.addEventListener('input', function () {
      var accordion = input.closest('.bb-col-filter__accordion');
      if (accordion && input.value !== '') {
        accordion.open = true;
      }
    });
  });

  section.querySelectorAll('.bb-col-filter__accordion').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      section.querySelectorAll('.bb-col-filter__accordion[open]').forEach(function (other) {
        if (other === details) return;
        if (accordionHasSelection(other)) return;
        other.open = false;
      });
    });
  });
})();
